module.exports = function (md) {
  const expectOpener = '<!--';
  const expectCloser = '-->';

  md.core.ruler.before('block', 'comment', (state, silent) => {
    if (silent) {
      return false;
    }

    if (!state.src.includes(expectOpener) || !state.src.includes(expectCloser)) {
      return false;
    }

    state.src = state.src.replace(/<!--[\s\S]*?-->/g, '');

    return true;
  });
};
